module.exports = __webpack_public_path__ + "img/ball_3_transparent.80990eb6.png";